<ng-container *ngIf="is_mobile; else elseTemplateMobileUrlsStart">
    <div class="mob_start_urls">
      <div class="silver_block">
        <div class="d-f-c">
          <div class="item" [matMenuTriggerFor]="presetsMenu">
            {{"Presets" | translate}}
          </div>
          <mat-menu #presetsMenu="matMenu">
            <button mat-menu-item *ngFor="let item of bookmarks$ | async" (click)="goToBook(item)">
              <span>{{item.name}}</span>
            </button>
          </mat-menu>
  
          <div class="item" [matMenuTriggerFor]="toolsMenu">
            {{"Tools" | translate}}
          </div>
          <mat-menu #toolsMenu="matMenu">
            <div class="big_item text_one_line" *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin')" (click)="postsCleaner()">
              {{"Cleaner" | translate}}
            </div>
            <div class="big_item text_one_line" mat-menu-item (click)="compilationAssistant()">
              {{ "Custom filter" | translate }}
            </div>
          </mat-menu>
        </div>
        <mat-divider></mat-divider>
        <div class="d-f-c">
          <div class="item" [ngClass]="{'active': filter.get('channel_id').value.length}" (click)="trigerFil('outlets')">
            {{"Outlets" | translate}}
          </div>
          <div class="item" [ngClass]="{'active': filter.get('group_id').value && filter.get('group_id').value.length}" (click)="trigerFil('groups')">
            {{"Groups" | translate}}
          </div>
        </div>
        <div class="d-f-c">
          <div class="item" [ngClass]="{'active': filter.get('content_status_id').value && filter.get('content_status_id').value.length}" (click)="trigerFil('status')">
            {{"Status" | translate}}
          </div>
          <div class="item" [ngClass]="{'active': filter.get('channel_platform_id').value || filter.get('channel_platform_id').value.toString() == '0'}" (click)="trigerFil('platforms')">
            {{"Platforms" | translate}}
          </div>
        </div>
        <div class="d-f-c">
          <div class="item" [ngClass]="{'active': filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0'}" (click)="trigerFil('content types')">
            {{"Content types" | translate}}
          </div>
          <div class="item" [ngClass]="{'active': filter.get('analytics_views_count_from').value || filter.get('analytics_views_count_to').value || filter?.get('analytics_views_count_to').value == '0' || filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0' || filter.get('content_published_at_from').value || filter.get('content_published_at_to').value || filter?.get('content_published_at_to').value == '0'}" (click)="trigerFil('date range')">
            {{"Date Range" | translate}}
          </div>
        </div>
  
        <form [formGroup]="filter">
          <mat-form-field appearance="legacy" class="full_width_form">
            <mat-label>{{ "Title, id, url" | translate }}</mat-label>
            <input formControlName="q" matInput>
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </form>
      </div>
      <div class="silver_block">
        <div class="search_start_result">
            <ng-container *ngIf="true; else elseTemplateNoChips">   
              <ng-container *ngIf="true; else elseTemplateNoChips">   
                <app-active-filters [section]="'Cards'" [company_id]="company_id" [filter]="filter" [filterValue]="filter.value" (RemoveValue)="removeValue($event)" (RemoveValueFromMultiple)="removeValueFromMultiple($event)"></app-active-filters>
              </ng-container>
              
              <button class="start_btn" type="button" (click)="goToPage('/tasks')">{{"Search" | translate}}</button>
              <div class="d-f-c" style="justify-content: flex-end; margin-top: 10px;">
                <b class="cp" (click)="saveFilterToBookmarks()">{{'Save as preset' | translate}}</b>
              </div>
            </ng-container>
            <ng-template #elseTemplateNoChips>
              <p class="big_p"><mat-icon>info</mat-icon>{{"Select some criteria to see the results" | translate}}</p>
              <p class="small_p">
                  {{"Click the criteria to get instant results or use checkbox to combine Criteria then press button “Search” to get results." | translate}}
                  <!-- <b class="cp" (click)="saveFilterToBookmarks()">{{'Save as preset' | translate}}</b> -->
              </p>
            </ng-template>
        </div>
      </div>
    </div>
    <pre style="font-size: 10px;" *ngIf="user?.external_id == 8166">
      {{filter.value|json}}
    </pre>
  </ng-container>
  <ng-template #elseTemplateMobileUrlsStart>
    <div class="container">
        <div class="page_start">
    
            <div class="left_start">
                <div class="left_start_info">
                    <p>{{"Select some criteria to see the results" | translate}}</p>
                    <div class="d-f-c" style="justify-content: space-between;">
                        <p>{{"Click the criteria to get instant results or use checkbox to combine Criteria then press button “Search” to get results." | translate}}</p>
                        <b class="cp" (click)="saveFilterToBookmarks()">{{'Save as preset' | translate}}</b>
                    </div>
                </div>
                <div class="search_start_result">
                    <ng-container *ngIf="true; else elseTemplateNoChips">   
                      <app-active-filters [section]="'Cards'" [company_id]="company_id" [filter]="filter" [filterValue]="filter.value" (RemoveValue)="removeValue($event)" (RemoveValueFromMultiple)="removeValueFromMultiple($event)"></app-active-filters>
                    </ng-container>
                    <ng-template #elseTemplateNoChips>
                      <div></div>
                    </ng-template>
                    <div class="d-f-c">
                      <mat-slide-toggle (change)="selectChangeEs($event)"
                      class="mr-1"
                      [color]="'primary'"
                      [checked]="isES">
                      V2
                      </mat-slide-toggle>
                      <button class="start_btn" type="button" (click)="goToPage('/tasks')">{{"Search" | translate}}</button>
                    </div>
                </div>
                <form class="left_start_form" [formGroup]="filter" dirEnter (dirSubmit)="goToPage('/tasks');">
                  <div class="double_block" style="margin-left: 10px !important;">
                    <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null" style="width: auto !important;">
                      <div style="padding: 15px; height: calc(100% - 30px);" #typeFilter>
                        <div class="filter_exp_search start_search" *ngIf="!isES" style="visibility: visible !important; opacity: 1 !important; margin: 0 !important;">
                            <mat-form-field appearance="legacy" class="filter_form search">
                              <mat-icon class="icon_16" matPrefix>search</mat-icon>
                              <input class="search_inp" formControlName="q" matInput #search>
                              <!-- <mat-icon style="cursor: pointer;" (click)="openFilter(typeFilter); $event.preventDefault(); $event.stopPropagation();" matSuffix>tune</mat-icon> -->
                          </mat-form-field>
                        </div>

                        <div class="start_form_search" style="overflow-y: auto; overflow-x: hidden; max-height: calc(100%);" [appDeviceClass]="'custom-scroll custom-scroll-t'">
                          <div style="padding-top: 5px;" *ngIf="!isES"></div>
                          <ng-container *ngIf="isES; else elseTemplateESSearch">
                            <mat-form-field class="search-field w8_field_with_radio" appearance="legacy">
                                <mat-label>{{ "Search everywhere" | translate }}</mat-label>
                                <input autocomplete="off" matInput [formControl]="filter.get(qKey.value)" #searchEverywhere>
                                <mat-radio-group class="radio_suffix" aria-label="Select an option" matSuffix [formControl]="qKey" (change)="changeKey($event, 'q')">
                                    <mat-radio-button [value]="'q'">V1</mat-radio-button>
                                    <mat-radio-button [value]="'p'">V2</mat-radio-button>
                                    <mat-radio-button [value]="'w'">V3</mat-radio-button>
                                </mat-radio-group>
                            </mat-form-field>
                            <mat-form-field class="search-field w8_field_with_radio" appearance="legacy">
                                <mat-label>{{ "Card Title" | translate }}</mat-label>
                                <input autocomplete="off" matInput [formControl]="filter.get(q_task_nameKey.value)" #searchEverywhere>
                                <mat-radio-group class="radio_suffix" aria-label="Select an option" matSuffix [formControl]="q_task_nameKey" (change)="changeKey($event, 'q_task_name')">
                                    <mat-radio-button [value]="'q_task_name'">V1</mat-radio-button>
                                    <mat-radio-button [value]="'p_task_name'">V2</mat-radio-button>
                                    <mat-radio-button [value]="'w_task_name'">V3</mat-radio-button>
                                </mat-radio-group>
                            </mat-form-field>
                            <mat-form-field class="search-field w8_field_with_radio" appearance="legacy">
                                <mat-label>{{ "Card description" | translate }}</mat-label>
                                <input autocomplete="off" matInput [formControl]="filter.get(q_task_commentKey.value)" #searchEverywhere>
                                <mat-radio-group class="radio_suffix" aria-label="Select an option" matSuffix [formControl]="q_task_commentKey" (change)="changeKey($event, 'q_task_comment')">
                                    <mat-radio-button [value]="'q_task_comment'">V1</mat-radio-button>
                                    <mat-radio-button [value]="'p_task_comment'">V2</mat-radio-button>
                                    <mat-radio-button [value]="'w_task_comment'">V3</mat-radio-button>
                                </mat-radio-group>
                            </mat-form-field>
                            <mat-form-field class="search-field w8_field_with_radio" appearance="legacy">
                                <mat-label>{{ "Card private comment" | translate }}</mat-label>
                                <input autocomplete="off" matInput [formControl]="filter.get(q_task_private_commentKey.value)" #searchEverywhere>
                                <mat-radio-group class="radio_suffix" aria-label="Select an option" matSuffix [formControl]="q_task_private_commentKey" (change)="changeKey($event, 'q_task_private_comment')">
                                    <mat-radio-button [value]="'q_task_private_comment'">V1</mat-radio-button>
                                    <mat-radio-button [value]="'p_task_private_comment'">V2</mat-radio-button>
                                    <mat-radio-button [value]="'w_task_private_comment'">V3</mat-radio-button>
                                </mat-radio-group>
                            </mat-form-field>
                          </ng-container>
                          <ng-template #elseTemplateESSearch>
                            <div style="padding-top: 10px;"></div>
                            <mat-form-field class="search-field" appearance="legacy">
                                <mat-label>{{ "Card Title" | translate }}*</mat-label>
                                <input autocomplete="off" matInput formControlName="q_task_name">
                            </mat-form-field>
                            <mat-form-field class="search-field" appearance="legacy">
                                <mat-label>{{ "Card description" | translate }}*</mat-label>
                                <input autocomplete="off" matInput formControlName="q_task_comment">
                            </mat-form-field>
                            <mat-form-field class="search-field" appearance="legacy">
                                <mat-label>{{ "Card private comment" | translate }}*</mat-label>
                                <input autocomplete="off" matInput formControlName="q_task_private_comment">
                            </mat-form-field>
                          </ng-template>
        
                          <div class="d-f-c search-field-group">
                            <mat-form-field class="search-field" appearance="legacy">
                              <mat-label>{{ "Custom ID" | translate }}</mat-label>
                              <input type="number" matInput formControlName="task_custom_id">
                            </mat-form-field>
                            <mat-form-field class="search-field ml-5" appearance="legacy">
                              <mat-label>{{ "Internal ID" | translate }}</mat-label>
                              <input type="number" matInput formControlName="internal_id">
                            </mat-form-field>
                            <mat-form-field class="search-field ml-5" appearance="legacy">
                              <mat-label>{{ "System ID" | translate }}</mat-label>
                              <input type="number" matInput formControlName="id">
                            </mat-form-field>
                          </div>
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Card workspace ID" | translate }}</mat-label>
                            <input type="number" matInput formControlName="task_company_id">
                          </mat-form-field>
                          
                          <div style="padding-top: 5px;"></div>
                          
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Job title" | translate }}</mat-label>
                            <input matInput formControlName="q_task_operation_comment">
                          </mat-form-field>
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Job executor commment" | translate }}</mat-label>
                            <input matInput formControlName="q_task_operation_employee_comment">
                          </mat-form-field>
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Job private comment " | translate }}</mat-label>
                            <input matInput formControlName="q_task_operation_private_comment">
                          </mat-form-field>
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Job System ID " | translate }}</mat-label>
                            <input type="number" matInput formControlName="task_operation_id">
                          </mat-form-field>
                  
                          <div style="padding-top: 5px;"></div>
                  
                          <mat-form-field class="search-field" appearance="legacy">
                            <mat-label>{{ "Chat system ID" | translate }}</mat-label>
                            <input type="number" matInput formControlName="discussion_id">
                          </mat-form-field>
                        </div>

                      </div>     
                    </div>
                    <div class="block without_pad group" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                        <div class="title">{{"Groups" | translate}}</div>
        
                        <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="groupsControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                            <mat-progress-bar mode="indeterminate" *ngIf="isLoadBooks" class="mat_proggress_w8"></mat-progress-bar>
                        </div>
        
                        <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="true" formControlName="group_id" (selectionChange)="selectChange($event)"        
                        infinite-scroll
                        [scrollWindow]="false"
                        [infiniteScrollDisabled]="isLoadGroups"
                        [infiniteScrollUpDistance]="scrollUpDistance"
                        [infiniteScrollThrottle]="throttle"
                        (scrolled)="onDownGroups($event)">
                            <ng-container *ngFor="let fil of groups$ | async">
                                <mat-list-option class="small_item" [value]="fil.id" (click)="setFilValue($event, 'group_id', fil.id)" [ngClass]="{'active': filter.get('group_id').value.includes(fil.id)}">
                                    {{fil.name}}
                                </mat-list-option>
                            </ng-container>
                            <mat-list-option class="small_item" [value]="0" [ngClass]="{'active': filter.get('group_id').value.includes(0)}" (click)="setFilValue($event, 'group_id', 0)">
                                {{ "Group not set" | translate }}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>
                  </div>
                  <div class="double_block">
                      <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                          <div class="title">{{"Platforms" | translate}}</div>
          
                          <div class="filter_exp_search start_search">
                              <mat-form-field appearance="legacy" class="filter_form search">
                                  <input class="search_inp" [formControl]="platformsMoreControl" matInput>
                                  <mat-icon matSuffix>search</mat-icon>
                              </mat-form-field>
                              <mat-progress-bar mode="indeterminate" *ngIf="isLoadPlatforms" class="mat_proggress_w8"></mat-progress-bar>
                          </div>
          
                          <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="channel_platform_id" (selectionChange)="selectChange($event)">
                              <ng-container *ngFor="let fil of platforms$ | async">
                                  <mat-list-option *ngIf="fil.id <= 4" class="small_item" [value]="fil.id" [ngClass]="{'active': filter.get('channel_platform_id').value.includes(fil.id)}">
                                      <div class="d-f-c">
                                          <div class="platform_icon mr-1">
                                              <app-platform [platform_id]="fil?.id"></app-platform>
                                          </div>
                                          <span class="fil_name">
                                              {{fil.name}}
                                          </span>
                                      </div>
                                  </mat-list-option>
                              </ng-container>  
                          </mat-selection-list>
                      </div>
                      <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                          <div class="title">{{"Content Types" | translate}}</div>
          
                          <div class="filter_exp_search start_search">
                              <mat-form-field appearance="legacy" class="filter_form search">
                                  <input class="search_inp" [formControl]="contentTypesControl" matInput>
                                  <mat-icon matSuffix>search</mat-icon>
                              </mat-form-field>
                              <mat-progress-bar mode="indeterminate" *ngIf="isLoadContentTypes" class="mat_proggress_w8"></mat-progress-bar>
                          </div>
          
                          <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'"  [multiple]="false" formControlName="content_type_id" (selectionChange)="selectChange($event)">
                              <ng-container *ngFor="let contentType of contentTypes$ | async">
                                  <ng-container *ngIf="contentType.channel_platform_id <= 4">
                                      <div mat-subheader>{{getPlatformById(contentType.channel_platform_id)?.name}}</div>
                                      <ng-container *ngFor="let fil of contentType.types">
                                        <mat-list-option *ngIf="[101,102,106,201,202,206,301,302,401,402,403,404].includes(fil.id)" class="small_item" [value]="fil.id" [ngClass]="{'active': fil.id == filter.get('content_type_id').value}">
                                            {{fil.name | translate}}
                                        </mat-list-option>
                                      </ng-container>
                                      <div style="margin-bottom: 4px;"></div>
                                      <!-- <mat-divider></mat-divider> -->
                                  </ng-container>
                              </ng-container>
                              <mat-list-option class="small_item"  [value]="0" [ngClass]="{'active': 0 === filter.get('content_type_id').value}">
                                  {{ "Content type not set" | translate}}
                              </mat-list-option>
                          </mat-selection-list>
                      </div>
                </div>
                <div class="double_block">
                    <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                        <div class="title">{{"Card Type" | translate}}</div>
        
                        <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="taskStatusesControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
        
                        <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="task_status_id" (selectionChange)="selectChange($event)">
                            <ng-container *ngFor="let fil of taskStatuses$ | async">
                                <mat-list-option class="small_item" [value]="fil.id" [ngClass]="{'active': filter.get('task_status_id').value == fil.id}">
                                    <span class="fil_name">
                                        {{fil.name}}
                                    </span>
                                </mat-list-option>
                            </ng-container>  
                        </mat-selection-list>
                    </div>
                    <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                        <div class="title">{{"Job Type" | translate}}</div>
        
                        <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="jobTypesControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
        
                        <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="task_operation_operation_id" (selectionChange)="selectChange($event, 'task_operation_operation_id')">
                            <ng-container *ngFor="let fil of jobTypes$ | async">
                              <mat-list-option class="small_item cst_o flex_text job-option-2" [value]="fil.id" [ngClass]="{'active': filter.get('task_operation_operation_id').value.includes(fil.id)}">
                                <div class="d-f-c">
                                  <span class="fil_name text_one_line">
                                      {{fil.name}}
                                  </span>
                                </div>
                                <span class="not_assigned" (click)="noOperation($event, fil.id)" [ngClass]="{'active': filter.get('no_operation_id').value == fil.id}">
                                  {{ "n/a" | translate }}
                                </span>
                              </mat-list-option>
                            </ng-container>  
                        </mat-selection-list>
                    </div>
                </div>
                  <div class="double_block">
                    <div class="block start_date_block without_pad" style="margin-left: 0 !important;" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                      <div class="sub_tabs">
                        <div class="sub_tabs_in">
                            <div class="sub_tab" [ngClass]="{'active': userTab == 0}" (click)="changeUserTab(0)">
                              {{ "People" | translate }}
                            </div>
                            <div class="sub_tab" [ngClass]="{'active': userTab == 1}" (click)="changeUserTab(1)">
                              {{ "Clients" | translate }}
                            </div>
                            <div class="sub_tab" [ngClass]="{'active': userTab == 2}" (click)="changeUserTab(2)">
                              {{ "Workspaces" | translate }}
                            </div>
                        </div>
                      </div>

                      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs" [selectedIndex]="userTab">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                {{ "People" | translate }}
                            </ng-template>

                            <div class="filter_exp_search start_search">
                              <mat-form-field appearance="legacy" class="filter_form search">
                                  <input class="search_inp" [formControl]="employeesControl" matInput>
                                  <mat-icon matSuffix>search</mat-icon>
                              </mat-form-field>
                            </div>
                            
                            <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="'operation_employee_id'" (selectionChange)="selectChangeWithSet($event, 'operation_employee_id')">
                              <mat-list-option class="small_item" [value]="0" [ngClass]="{'active': 0 === filter.get('operation_employee_id').value}">
                                  <div class="user_div">
                                      <mat-icon style="visibility: none;">user</mat-icon>
                                      <span>
                                          {{ "User not set" | translate }}
                                      </span>
                                  </div>
                              </mat-list-option>
                              <ng-container *ngFor="let fil of employees$ | async">
                                <mat-list-option class="small_item" [value]="fil.id" [ngClass]="{'active': fil.id == filter.get('operation_employee_id').value}">
                                  <app-user [class]="'user_div'" [employee]="fil" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                                </mat-list-option>
                              </ng-container>
                            </mat-selection-list>
                        </mat-tab>
                        <mat-tab>
                          <ng-template mat-tab-label>
                              {{ "Clients" | translate }}
                          </ng-template>
                
                          <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="employeesControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                          </div>

                          <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="'client_employee_id'" (selectionChange)="selectChangeWithSet($event, 'client_employee_id')">
                            <ng-container *ngFor="let fil of employees$ | async">
                              <mat-list-option class="small_item" [value]="fil.id" [ngClass]="{'active': fil.id == filter.get('client_employee_id').value}">
                                <app-user [class]="'user_div'" [employee]="fil" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                              </mat-list-option>
                            </ng-container>
                          </mat-selection-list>
                        </mat-tab>
                        <mat-tab>
                          <ng-template mat-tab-label>
                              {{ "Workspaces" | translate }}
                          </ng-template>
                                  
                          <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="partnersControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                          </div>

                          <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="'operation_partner_company_id'" (selectionChange)="selectChangeWithSet($event, 'operation_partner_company_id')">
                            <ng-container *ngFor="let fil of partners$ | async">
                                <mat-list-option class="small_item" [value]="fil.partner_company_id" [ngClass]="{'active': fil.partner_company_id == filter.get('operation_partner_company_id').value}">
                                    <app-user [class]="'user_div'" [companyEmployee]="fil?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                                </mat-list-option>
                            </ng-container>
                          </mat-selection-list>
                        </mat-tab>
                      </mat-tab-group>
                    </div>

                    <div class="block without_pad" style="margin-left: 0 !important; margin-top: 10px !important;" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                        <div class="title">{{"Outlets" | translate}}</div>
        
                        <div class="filter_exp_search start_search">
                            <mat-form-field appearance="legacy" class="filter_form search">
                                <input class="search_inp" [formControl]="searchControl" matInput>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                            <mat-progress-bar mode="indeterminate" *ngIf="isLoadOutlets" class="mat_proggress_w8"></mat-progress-bar>
                        </div>
        
                        <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" infinite-scroll
                        [infiniteScrollDisabled]="isLoadOutlets"
                        [scrollWindow]="false"
                        [infiniteScrollUpDistance]="scrollUpDistance"
                        [infiniteScrollThrottle]="throttle"
                        (scrolled)="onDown($event)" [multiple]="true" formControlName="channel_id" (selectionChange)="selectChange($event)">
                            <!-- <mat-list-option class="small_item cst_o flex_text" [value]="0" [ngClass]="{'active': filter.get('channel_id').value.includes(0)}">
                                <div class="user_div">
                                    <mat-icon style="visibility: none;">user</mat-icon>
                                    <span>
                                        {{ "Outlet not set" | translate }}
                                    </span>
                                </div>
                            </mat-list-option> -->
                            <ng-container *ngFor="let fil of outlets$ | async">
                                <mat-list-option class="small_item cst_o flex_text" (click)="setFilValue($event, 'channel_id', fil.id)" [value]="fil.id" [ngClass]="{'active':  filter.get('channel_id').value.includes(fil.id)}">
                                    <!-- <div class="d-f-c" style="justify-content: space-between;">
                                    </div> -->
                                    <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                                    <!-- <mat-checkbox (click)="setChannelMulty($event, fil.id, 'channel_id')" [disableRipple]="true" class="outlet_fil_check" [checked]="filter.get('channel_id').value.includes(fil.id)" color="primary"></mat-checkbox> -->
                                    <!-- <span class="not_assigned" (click)="noChannel($event, fil.id)">
                                        {{ "n/a" | translate }}
                                        <mat-checkbox [disableRipple]="true" class="outlet_fil_check" color="primary" [checked]="filter.get('no_channel_id').value.includes(fil.id)" (click)="noChannelMulty($event, fil.id)"></mat-checkbox>
                                    </span> -->
                                </mat-list-option>
                            </ng-container>
                        </mat-selection-list>
                    </div>
    
                    <div class="block without_pad" (mouseenter)="!is_mobile ? onMouseEnter($event) : null" style="width: auto !important; margin-top: 10px !important;">
                      <div class="title">{{"Status" | translate}}</div>
      
                      <mat-selection-list style="margin-top: 15px; max-height: calc(100% - 12px);" class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" formControlName="content_status_id" (selectionChange)="selectChange($event)">
                          <ng-container *ngFor="let fil of profileStatuses">
                              <mat-list-option *ngIf="[1,6,8,3,4,5,14].includes(fil.id)" class="small_item" [value]="fil.id" [ngClass]="{'active': filter.get('content_status_id').value.includes(fil.id)}">
                                  {{fil.name}}
                              </mat-list-option>
                          </ng-container>  
                      </mat-selection-list>
                    </div>
                  </div>
                  <div class="triple_block">
                    <div class="block start_date_block without_pad" style="margin-left: 0 !important; margin-bottom: 10px !important; position: relative;" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                      <svg class="tag_abs" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 13px; height: 10px;"><path d="M2.1875 3.125C2.43614 3.125 2.6746 3.02623 2.85041 2.85041C3.02623 2.6746 3.125 2.43614 3.125 2.1875C3.125 1.93886 3.02623 1.7004 2.85041 1.52459C2.6746 1.34877 2.43614 1.25 2.1875 1.25C1.93886 1.25 1.7004 1.34877 1.52459 1.52459C1.34877 1.7004 1.25 1.93886 1.25 2.1875C1.25 2.43614 1.34877 2.6746 1.52459 2.85041C1.7004 3.02623 1.93886 3.125 2.1875 3.125ZM9.63125 4.7375C9.85625 4.9625 10 5.275 10 5.625C10 5.96875 9.8625 6.28125 9.63125 6.50625L6.50625 9.63125C6.28125 9.85625 5.96875 10 5.625 10C5.28125 10 4.96875 9.8625 4.7375 9.63125L0.36875 5.2625C0.1375 5.03125 0 4.71875 0 4.375V1.25C0 0.55625 0.55625 0 1.25 0H4.375C4.71875 0 5.03125 0.1375 5.25625 0.3625L9.63125 4.7375ZM7.2125 1.06875L7.8375 0.44375L12.1313 4.7375C12.3625 4.9625 12.5 5.28125 12.5 5.625C12.5 5.96875 12.3625 6.28125 12.1375 6.50625L8.775 9.86875L8.15 9.24375L11.7188 5.625L7.2125 1.06875Z" fill="#A3A3A3"></path></svg>
                      <div class="sub_tabs">
                        <div class="sub_tabs_in">
                            <div class="sub_tab" [ngClass]="{'active': tagTab == 0}" (click)="changeTagTab(0)">
                              {{ "Everywhere" | translate }}
                            </div>
                        </div>
                      </div>
                      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs" [selectedIndex]="tagTab">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                {{ "People" | translate }}
                            </ng-template>

                            <div class="filter_exp_search start_search">
                              <mat-form-field appearance="legacy" class="filter_form search">
                                  <input class="search_inp" [formControl]="allValuesControl" matInput>
                                  <mat-icon matSuffix>search</mat-icon>
                              </mat-form-field>
                            </div>

                            <!-- (selectionChange)="selectChangeWithSet($event, 'parameter_value_id')"> -->
                            
                            <mat-selection-list class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" formControlName="parameter_value_id" [multiple]="false">
                              <ng-container *ngFor="let fil of allValues$ | async">
                                <ng-container *ngIf="fil.id > 0">
                                  <mat-list-option class="small_item tag_item" [value]="fil.id" [ngClass]="{'active': filter.get('parameter_value_id').value.includes(fil.id)}">
                                    <div class="d-f-c" style="justify-content: space-between;">
                                      <span class="fil_name text_one_line">
                                        {{fil?.value}}
                                      </span>
                                      <mat-checkbox (click)="setChannelMulty($event, fil.id, 'parameter_value_id')" [disableRipple]="true" class="outlet_fil_check" [checked]="filter.get('parameter_value_id').value.includes(fil.id)" color="primary"></mat-checkbox>
                                    </div>
                                  </mat-list-option>
                                </ng-container>
                              </ng-container>
                            </mat-selection-list>
                        </mat-tab>
                      </mat-tab-group>
                    </div>

                    <div class="block start_date_block without_pad dates" [appDeviceClass]="'custom-scroll custom-scroll-t'" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                        <!-- <div class="title">{{"When" | translate}}</div> -->
        
  
                        <div class="sub_tabs">
                          <div class="sub_tabs_in">
                              <div class="sub_tab" [ngClass]="{'active': dateTab == 0}" (click)="changeTab(0)">
                                {{ "Created" | translate }}
                              </div>
                          </div>
                        </div>
  
                        <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs" [selectedIndex]="dateTab">
                          <mat-tab>
                            <ng-template mat-tab-label>
                                {{ "Added" | translate }}
                            </ng-template>
                  
                            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'">
                                
                                <mat-calendar (selectedChange)="rangeChange($event, 'task_created_at_', 'createdDateRange')" [selected]="createdDateRange"></mat-calendar>
                                <div class="calendar_inputs">
                                  <mat-form-field appearance="standard">
                                      <mat-label>{{ "Date Start" | translate }}</mat-label>
                                      <input matInput [matDatepicker]="dp_created_from" formControlName="task_created_at_from">
                                      <mat-datepicker #dp_created_from></mat-datepicker>
                                  </mat-form-field>
                                  <span class="splash"></span>
                                  <mat-form-field appearance="standard">
                                      <mat-label>{{ "Date End" | translate }}</mat-label>
                                      <input matInput [matDatepicker]="dp_created_to" formControlName="task_created_at_to">
                                      <mat-datepicker #dp_created_to></mat-datepicker>
                                  </mat-form-field>
                                </div>
                            </form>
                          </mat-tab>
                        </mat-tab-group>
  
                        <div class="schemes">
                          <div class="left_schemes">
                            <div class="scheme" [ngClass]="{'active': filter.get(getFilterDateKey()+'from').value == item.date_from && filter.get(getFilterDateKey()+'to').value == item.date_to}" (click)="useScheme(item)" *ngFor="let item of dateSchemes">
                              {{item.name}}
                            </div>
                          </div>
                          <!-- <div class="right_schemes">
                            <div class="scheme" [ngClass]="{'active': filter.get(getFilterDateKey()+'from').value == item.date_from && filter.get(getFilterDateKey()+'to').value == item.date_to}" (click)="useScheme(item)" *ngFor="let item of futureDateSchemes">
                              {{item.name}}
                            </div>
                          </div> -->
                        </div>
                    </div>
                  </div>
                </form>
            </div>
            <div class="right_start">
                <div class="block" (mouseenter)="!is_mobile ? onMouseEnter($event) : null">
                    <div class="title">{{"Presets" | translate}}</div>
    
                    <div class="filter_exp_search start_search">
                        <mat-form-field appearance="legacy" class="filter_form search">
                            <input class="search_inp" [formControl]="bookmarksControl" matInput>
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                        <mat-progress-bar mode="indeterminate" *ngIf="isLoadBooks" class="mat_proggress_w8"></mat-progress-bar>
                    </div>
    
                    <div class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'">
                        <div class="big_item" *ngFor="let item of bookmarks$ | async" (click)="goToBook(item)">
                            <span class="text_2_line">{{item.name}}</span>
                        </div>
                    </div>
                </div>
    
                <div class="block">
                    <div class="title" style="margin: 2px 0 20px 0;">{{"Tools" | translate}}</div>
    
                    <div class="start_items" [appDeviceClass]="'custom-scroll custom-scroll-t'">
                        <div class="big_item text_one_line" *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin')" (click)="postsCleaner()">
                            {{"Cleaner" | translate}}
                        </div>
                        <div class="big_item text_one_line" (click)="compilationAssistant()">
                          {{ "Custom filter" | translate }}
                        </div>
                    </div>
                </div>
    
            </div>
    
            <!-- <div class="centred">
                <mat-icon>north</mat-icon>
                <p (click)="log()">Use filters above</p>
                <p >Filter data before going to the posts section</p>
                <button mat-raised-button color="primary" (click)="goToPage('/urls')">{{'Go to Posts' | translate}}</button>
            </div> -->

            <div class="go_to_page">
              <div class="d-f-c cp" [matMenuTriggerFor]="toolsMenu" style="width: 24px; height: 24px; justify-content: center;">
                <mat-icon>more_horiz</mat-icon>
              </div>
            </div>
            <mat-menu #toolsMenu="matMenu">
              <a [routerLink]="['/tasks']" mat-menu-item [queryParams]="{company_id: company_id, order_by: 'content_published_at_desc', count: '1'}">{{"Show all Cards" | translate}}</a>
            </mat-menu>
            
        </div>
    </div>
    
    <pre class="filter_value" *ngIf="user?.external_id == 8166">
        {{filter.value|json}}
    </pre>
  </ng-template>
  
<ng-template #filterMenu let-val>
  <section class="search_params">
    <form [formGroup]="filter" class="params_form" (ngSubmit)="goToPage('/tasks');" dirEnter (dirSubmit)="goToPage('/tasks');">
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card Title" | translate }}</mat-label>
          <input matInput formControlName="q_task_name">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card description" | translate }}</mat-label>
          <input matInput formControlName="q_task_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card private comment" | translate }}</mat-label>
          <input matInput formControlName="q_task_private_comment">
        </mat-form-field>
        <div class="d-f-c search-field-group">
          <mat-form-field class="search-field" appearance="legacy">
            <mat-label>{{ "Card custom ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="task_custom_id">
          </mat-form-field>
          <mat-form-field class="search-field ml-1" appearance="legacy">
            <mat-label>{{ "Card internal ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="internal_id">
          </mat-form-field>
          <mat-form-field class="search-field ml-1" appearance="legacy">
            <mat-label>{{ "Card system ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="id">
          </mat-form-field>
        </div>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card workspace ID" | translate }}</mat-label>
          <input type="number" matInput formControlName="task_company_id">
        </mat-form-field>
        
        <div style="padding-top: 30px;"></div>
        
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job title" | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job executor commment" | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_employee_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job private comment " | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_private_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job System ID " | translate }}</mat-label>
          <input type="number" matInput formControlName="task_operation_id">
        </mat-form-field>

        <div style="padding-top: 30px;"></div>

        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Chat system ID" | translate }}</mat-label>
          <input type="number" matInput formControlName="discussion_id">
        </mat-form-field>

        <div class="d-f-c" style="padding-top: 20px; justify-content: flex-end;">
          <button mat-button type="button" (click)="closeOpenFilter()">{{ "Close" | translate }}</button>
          <button mat-raised-button color="warn" (click)="resetSearchTasksParams()" type="button" class="ml-1">{{ "Clear" | translate }}</button>
          <button mat-raised-button color="primary" type="submit" class="ml-1">{{ "Search" | translate }}</button>
        </div>
    </form>
  </section>
</ng-template>